<template>
  <div>
    <div class="bargain-record" ref="UserGoodsBargainList">
      <div 
        class="item"
        v-for="(item,index) in bargainList"
        :key="index"
        >
        <div class="picTxt acea-row row-between-wrapper">
          <div class="pictrue">
            <img :src="item.image">
            </div>
          <div class="text acea-row row-column-around">
            <div class="line1">{{item.title}}</div>
            <div class="time">
              倒计时
              <span class="font-color">{{item.day}}</span>
              天
              <span class="font-color">{{item.hour}}</span>
              时
              <span class="font-color">{{item.minute}}</span>
              分
              <span class="font-color">{{item.second}}</span>
              秒
            </div>
            <div class="money font-color">
              已砍至
              <span class="symbol">￥</span>
              <span class="num">{{item.residue_price}}</span>
            </div>
          </div>
        </div>
        <div class="bottom acea-row row-between-wrapper">
          <div class="purple" v-if="item.is_del == 0 && item.status == 1">
            活动进行中
          </div>
          <div
            class="success"
            v-else-if="item.is_del == 0 && item.status == 3"
          >
            砍价成功
          </div>
          <div class="end" v-else-if="item.is_del == 0 && item.status == 2">
            活动已结束
          </div>
          <div class="end" v-else-if="item.is_del == 1">活动已取消</div>
          <div class="acea-row row-middle row-right">
            <div
              class="bnt cancel"
              v-if="item.is_del == 0 && item.status == 1"
              @click="showPopup(item)"
            >
              取消活动
            </div>
            <div
              class="bnt bg-color-linear"
              v-if="item.is_del == 0 && item.status == 1 && item.residue_price > item.bargain_price_min"
              @click="toBargain(item)"
            >
              继续砍价
            </div>
            <div
              class="bnt bg-color-linear"
              @click="toBargain(item)"
              v-if="item.status === 1"
            >
              立即付款
            </div>
            <div
              class="bnt bg-color-linear"
              v-if="item.status == 3"
              @click="toBargainList"
            >
              看看别的
            </div>
          </div>
        </div>
      </div>
    </div>
    <CancelBargainPopup
      :isShow="isShow"
      :bargainItem="bargainItem"
      @closePrePopup="closePrePopup"
      @cancelBargain="cancelBargain"
    ></CancelBargainPopup>
    <!-- 缺省图 -->
    <div class="noCommodity" v-if="bargainList.length==0 && !loading">
      <div class="pictrue">
        <img
          src="@assets/images/noShopper.png"
        >
      </div>
    </div>
  </div>
</template>
<script>
import { getBargainUserList, getBargainUserCancel} from "@api/activity"
import CancelBargainPopup from "@components/CancelBargainPopup"
export default {
  name: "UserGoodsBargainList",
  components:{
    CancelBargainPopup
  },
  data(){
    return{
      parameter: {
      'navbar': '1',
      'return': '1',
      'title': '砍价记录'
      },
      bargainList:[],
      page:1,
      limit:5,
      loading: false,
      status:false,
      timer:null,
      isShow:false,
      bargainItem:{}
    }
  },
  mounted(){
    this.getBargainList();
    this.$scroll(this.$refs.UserGoodsBargainList,() => {
      !this.loading && this.getBargainList();
    })
  },
  methods:{
    getBargainList() {
      var that = this;
      var bargainList = that.bargainList;
      var timer = that.timer;
      var page = that.page; 
      var limit = that.limit;
      var status = that.status;
      var bargainListNew = [];
      if (status == true) return this.$dialog.message("已全部加载");
      this.loading = true
      getBargainUserList({ page: page, limit: limit }).then(res=>{
        var len = res.data.length;
        var bargainListData = res.data;
        bargainListNew = bargainList.concat(bargainListData);
        if (timer != 0) clearInterval(timer);
        that.loading = false;
        that.bargainList = bargainListNew;
        that.bargainList.forEach(item=>{
          this.$set(item,"day",0)
          this.$set(item,"hour",0)
          this.$set(item,"minute",0)
          this.$set(item,"second",0)
        })
        timer = 0
        this.status = limit > len;
        this.page = page+1;
        that.setTime();
      })
      .catch(res => {
        that.loading = false
      })
    },
    setTime(){
      var that = this;
      var bargainList = that.bargainList;
      var len = bargainList.length;//时间数据长度
      function nowTime() {//时间函数
        for (var i = 0; i < len; i++) {
          var intDiff = bargainList[i].datatime - Date.parse(new Date()) / 1000;
          //获取数据中的时间戳的时间差；
          var day = 0, hour = 0, minute = 0, second = 0;
          if (intDiff > 0) {//转换时间
            day = Math.floor(intDiff / (60 * 60 * 24));
            hour = Math.floor(intDiff / (60 * 60)) - (day * 24);
            minute = Math.floor(intDiff / 60) - (day * 24 * 60) - (hour * 60);
            second = Math.floor(intDiff) - (day * 24 * 60 * 60) - (hour * 60 * 60) - (minute * 60);
            if (hour <= 9) hour = '0' + hour;
            if (minute <= 9) minute = '0' + minute;
            if (second <= 9) second = '0' + second;
            day = day;
            hour = hour;
            minute = minute;
            second = second;
          } else {
            day = "00";
            hour = "00";
            minute = "00";
            second = "00";
          }
          that.$set(bargainList[i],"day",day);
          that.$set(bargainList[i],"hour",hour);
          that.$set(bargainList[i],"minute",minute);
          that.$set(bargainList[i],"second",second);
        }
        that.bargainList = bargainList;
      }
      nowTime();
      var timer = setInterval(nowTime, 1000);
      that.timer = timer;
    },
    showPopup(item){
      this.isShow = true;
      this.bargainItem = item;
    },
    cancelBargain(item){
      var that = this;
      getBargainUserCancel({bargainId:item.id}).then(res=>{
        this.$dialog.success(res.msg)
        clearInterval(that.timer);
        that.timer = "";
        that.page = 0;
        that.status = false;
        that.bargainList = []   
        that.getBargainList();
        that.isShow = false;
      }).catch(err => {
        that.$dialog.error(err.msg);
        that.isShow = false;
      })
    },
    closePrePopup(){
      this.isShow = false;
    },
    toBargain(item){
      this.$router.push({
        path:`/activity/goods_bargain_details?id=${item.bargain_id}&bargain=${item.uid}`
      })
    },
    toBargainList(){
      this.$router.push({
        path:`/activity/goods_bargain`
      })
    }
  }
};
</script>
<style scoped>
.noCommodity .pictrue {
  width: 4.14rem;
  height: 3.36rem;
  margin: .75rem auto .3rem auto;
}
.noCommodity .pictrue img{
  width: 100%;
  height: 100%;
}
.font-color {
  color: #d2ac72!important;
}
.bargain-record .item {
  background-color: #fff;
  margin-top: .12rem;
  border-radius: 10px;
}
.bargain-record .item .picTxt {
  height: 2.1rem;
  border-bottom: 1px solid #f0f0f0;
  padding: 0 .3rem;
}
.bargain-record .item .picTxt .pictrue {
  width: 1.5rem;
  height: 1.5rem;
}
.bargain-record .item .picTxt .pictrue img {
  width: 100%;
  height: 100%;
  border-radius: 3px;
}
.bargain-record .item .picTxt .text {
  width: 5.15rem;
  font-size: .3rem;
  color: #282828;
  height: 1.5rem;
}
.bargain-record .item .picTxt .text .time {
  font-size: .24rem;
  color: #868686;
}
.bargain-record .item .picTxt .text .money {
  font-size: .24rem;
}
.bargain-record .item .picTxt .text .money .num {
  font-size: .32rem;
  font-weight: bold;
}
.bargain-record .item .picTxt .text .money .symbol {
  font-weight: bold;
}
.bargain-record .item .bottom {
  height: 1rem;
  padding: 0 .3rem;
  font-size: .27rem;
}
.bargain-record .item .bottom .purple {
  color: #ff6d40;
}
.bargain-record .item .bottom .end {
  color: #999;
}
.bargain-record .item .bottom .success {
  color: #ff554c;
}
.bargain-record .item .bottom .bnt {
  font-size: .27rem;
  color: #fff;
  width: 1.54rem;
  height: .6rem;
  border-radius: 15px;
  text-align: center;
  line-height: .6rem;
}
.bargain-record .item .bottom .bg-color-linear {
  background: linear-gradient(90deg, #ff554c, #ff6d40);
  box-shadow: 0 0 8px rgba(255, 85, 76, 0.6);
}
.bargain-record .item .bottom .bnt.cancel {
  color: #aaa;
  border: 1px solid #ddd;
}
.bargain-record .item .bottom .bnt {
  margin-left: .18rem;
}
</style>